import type { ChangeEvent } from "react";

import { adaptFormType } from "src/features/observationsAdmin/utils";

interface ObservationTypePickerProps {
	label: string;

	placeholder?: string;

	helperText?: string | JSX.Element;

	value?: string | number | readonly string[];

	defaultValue?: "" | IObservationType;

	isEditable?: boolean;

	onChange?: (value: IObservationType) => void;
}

const OBSERVATION_TYPES: IObservationType[] = [
	"INDIVIDUAL",
	"STORE_SCORED_ASSESSMENT",
	"STORE_SELF_ASSESSMENT",
	"GREAT_CONVERSATION"
];

const ObservationTypePicker = ({
	label,
	placeholder,
	helperText,
	defaultValue,
	isEditable,
	value,
	onChange
}: ObservationTypePickerProps) => {
	const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
		const value = e.target.value as IObservationType;
		onChange?.(value);
	};

	if (defaultValue && !isEditable) {
		return (
			<p>
				<span className="font-bold">Form type:</span>{" "}
				{adaptFormType(defaultValue)}
			</p>
		);
	}

	return (
		<div>
			<label
				htmlFor="observation-type-select"
				className="font-heading text-lg font-medium text-foreground mb-1 block"
			>
				{label}
			</label>

			{helperText && typeof helperText === "string" ? (
				<p className="text-[13px] text-muted-foreground mb-4">{helperText}</p>
			) : (
				helperText
			)}

			<select
				id="observation-type-select"
				className="flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
				value={value as string}
				onChange={handleChange}
			>
				{placeholder && (
					<option value="" disabled>
						{placeholder}
					</option>
				)}
				{OBSERVATION_TYPES.map((observationType) => (
					<option key={observationType} value={observationType}>
						{adaptFormType(observationType)}
					</option>
				))}
			</select>
		</div>
	);
};

export { ObservationTypePicker, type ObservationTypePickerProps };
